import React, {useEffect, useState} from 'react';
import {Button, Card, Col, Divider, Form, Input, message, Row,} from 'antd';
import {PlusOutlined,} from '@ant-design/icons';
import {defaultComment, formatRussianDate, getRussianDayName,} from "./helpers/helper";
import {Loader} from "./components/Loader";
import {TitleComp} from "./components/TitleComp";
import {TeamCard} from "./components/teamcard/TeamCard";
import {ModalsAndDrawers} from "./components/ModalsAndDrawers";
import './planning.css';
import {instance, whatsappApi} from "../../API/API";


const {TextArea} = Input;

const NewPlanning = ({edit = false, setPage}) => {
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(edit);
    const [staff, setStaff] = useState([]);
    const [objects, setObjects] = useState([]);
    const [cars, setCars] = useState([]);
    const [teams, setTeams] = useState([{
        id: 1,
        carId: '',
        driver: '',
        lead: '',
        staff: [],
        objects: [],
        teamcomment: ''
    }]);
    const [form] = Form.useForm();
    const [addStaffModalVisible, setAddStaffModalVisible] = useState(false);
    const [addObjectsModalVisible, setAddObjectsModalVisible] = useState(false);
    const [currentTeamIndex, setCurrentTeamIndex] = useState(0);
    const [selectedStaff, setSelectedStaff] = useState([]);
    const [selectedObjects, setSelectedObjects] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [planNumber, setPlanNumber] = useState('');
    const [planTitle, setPlanTitle] = useState('');
    const [currentPlanId, setCurrentPlanId] = useState(null);


    useEffect(() => {
        console.log(teams);
    }, [teams]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const dayName = getRussianDayName(tomorrow);
        const dateString = formatRussianDate(tomorrow);
        setPlanTitle(`План работ на ${dayName}, ${dateString}`);
        form.setFieldsValue({
            mainComment: defaultComment
        });
    }, [form, edit]);

    useEffect(() => {
        const loadReferenceData = async () => {
            try {
                const [staff_req, objects_req, cars_req] = await Promise.all([
                    instance.get(`staff/get_staff.php?role=3`),
                    instance.get(`objects/get_plans_objects.php`),
                    instance.get(`cars/get_plans_cars.php`)
                ]);

                if (staff_req.data?.staff) setStaff(staff_req.data.staff);
                if (objects_req.data?.objects) setObjects(objects_req.data.objects);
                if (cars_req.data?.cars) setCars(cars_req.data.cars);
            } catch (error) {
                console.error("Error loading reference data:", error);
                message.error('Ошибка загрузки справочных данных');
            }
        };
        loadReferenceData();
    }, []);

    useEffect(() => {
        const getInitData = async () => {
            try {
                setLoading(true);
                if (edit) {
                    // После загрузки справочных данных загружаем план
                    await loadPlanData();
                } else {
                    // РЕЖИМ СОЗДАНИЯ
                    await loadPlanNumber();
                    setTeams([{
                        id: 1,
                        carId: '',
                        driver: '',
                        lead: '',
                        staff: [],
                        objects: [],
                        teamcomment: ''
                    }])
                }

            } catch (e) {
                console.error("Error fetching data:", e);
                message.error('Ошибка загрузки данных');
            } finally {
                setLoading(false);
                setInitialLoading(false);
            }
        };

        const loadPlanData = async () => {
            try {
                const planResponse = await instance.get(`plans/get_plan.php`);

                if (planResponse.data.access && planResponse.data.plans && planResponse.data.plans.length > 0) {
                    const planData = planResponse.data.plans[0];
                    setCurrentPlanId(planData.id);

                    // Заполняем форму данными плана
                    form.setFieldsValue({
                        mainComment: planData.maincomment || defaultComment
                    });

                    // Преобразуем команды в формат компонента (ТОЛЬКО после загрузки справочных данных)
                    transformTeams(planData.props, planData);
                } else {
                    message.warning('Не найдено планов для редактирования');
                    setDefaultCreationState();
                }
            } catch (error) {
                console.error("Error loading last plan data:", error);
                message.error('Ошибка загрузки последнего плана');
                setDefaultCreationState();
            }
        };

        const loadPlanNumber = async () => {
            try {
                const planNumResponse = await instance.get(`plans/get_last_plan_num.php`);
                if (planNumResponse.data && planNumResponse.data.plan_number) {
                    setPlanNumber((planNumResponse.data.plan_number + 1).toString());
                } else {
                    setPlanNumber('Новый');
                }
            } catch (error) {
                console.error("Error getting plan number:", error);
                setPlanNumber('Новый');
            }
        };

        const setDefaultCreationState = () => {
            setPlanNumber('Новый');
            setPlanTitle(`План работ на ${formatRussianDate(new Date())}`);
            setTeams([{
                id: 1,
                carId: '',
                driver: '',
                lead: '',
                staff: [],
                objects: [],
                teamcomment: ''
            }]);
        };

        staff && objects && cars && getInitData()

    }, [edit, form, staff, objects, cars]);

    const transformTeams = (props, planData) => {
        const formattedTeams = props.map((prop, index) => {
            // Находим сотрудников по ID
            const staffMembers = prop.staff_id ? prop.staff_id.split(',').map(idStr => {
                const staffId = parseInt(idStr.trim());
                const staffMember = staff.find(s => s.id === staffId);
                return {
                    ...staffMember,
                    isDriver: parseInt(prop.driver) === staffId,
                    isLead: parseInt(prop.lead) === staffId
                };
            }) : [];

            // Находим объекты по ID
            const objectItems = prop.objects_id ? prop.objects_id.split(',').map((idStr, index) => {
                const objectId = parseInt(idStr.trim());
                const objectItem = objects.find(o => o.id === objectId);

                // Разбиваем общий комментарий на отдельные комментарии
                let objectComment = '';
                if (prop.comment) {
                    // Разделяем комментарии по точке с запятой или другому разделителю
                    const commentParts = prop.comment.split('`');

                    // Если количество частей комментария соответствует количеству объектов
                    if (commentParts.length === prop.objects_id.split(',').length) {
                        objectComment = commentParts[index]?.trim() || '';
                    }
                    // Или пытаемся найти комментарий по имени объекта
                    else if (objectItem) {
                        const objectNamePattern = new RegExp(`${objectItem.name}:\\s*([^;]+)`, 'i');
                        const match = prop.comment.match(objectNamePattern);
                        objectComment = match ? match[1].trim() : '';
                    }
                    // Или используем весь комментарий если он один для всех
                    else {
                        objectComment = prop.comment;
                    }
                }

                return {
                    ...objectItem,
                    id: objectId,
                    name: objectItem ? objectItem.name : `Объект ${objectId}`,
                    comment: objectComment
                };
            }) : [];

            return {
                id: prop.id || index + 1,
                carId: prop.car_id || '',
                driver: parseInt(prop.driver) || '',
                lead: parseInt(prop.lead) || '',
                staff: staffMembers,
                objects: objectItems,
                teamcomment: prop.teamcomment || ''
            };
        });

        setTeams(formattedTeams);
        setPlanNumber(planData.plan_number?.toString() || '');
        setPlanTitle(edit ? `Редактирование плана #${planData.id}` : `Новый план #${planData.id}`);
    };

    const getAvailableStaff = () => {
        const usedStaffIds = teams.flatMap(team => team.staff.map(s => String(s.id)));
        return staff.filter(person => !usedStaffIds.includes(String(person.id)));
    };

    const getAvailableObjects = (teamIndex = currentTeamIndex) => {
        // Берем использованные объекты только из текущей команды
        const usedObjectIds = teams[teamIndex]?.objects.map(obj => String(obj.id)) || [];
        return objects.filter(obj => !usedObjectIds.includes(String(obj.id)));
    };

    const getAvailableCars = () => {
        const usedCarIds = teams.map(team => team.carId).filter(id => id !== '');
        return cars.filter(car =>
            // Исключаем машину "Своим ходом" (id: "99") из фильтрации
            car.id === "99" || !usedCarIds.includes(car.id)
        );
    };

    const reloadPlanData = async () => {
        try {
            if (!currentPlanId) return;

            setLoading(true);
            const planResponse = await instance.get(`plans/get_plan.php?plan_id=${currentPlanId}`);

            if (planResponse.data.access && planResponse.data.plans && planResponse.data.plans.length > 0) {
                const planData = planResponse.data.plans[0];

                // Обновляем форму
                form.setFieldsValue({
                    mainComment: planData.maincomment || defaultComment
                });

                // Преобразуем команды
                transformTeams(planData.props, planData);

                message.success('Данные плана обновлены');
            }
        } catch (error) {
            console.error("Error reloading plan data:", error);
            message.error('Ошибка обновления данных плана');
        } finally {
            setLoading(false);
        }
    };

    const addTeam = () => {
        setTeams([...teams, {
            id: teams.length + 1,
            carId: '',
            driver: '',
            lead: '',
            staff: [],
            objects: [],
            teamcomment: ''
        }]);
    };

    const removeTeam = (index) => {
        if (teams.length > 1) {
            const updatedTeams = teams.filter((_, i) => i !== index);
            setTeams(updatedTeams);
        }
    };

    const addStaffToTeam = (teamIndex, staffItems) => {
        const updatedTeams = [...teams];
        staffItems.forEach(staffItem => {
            if (!updatedTeams[teamIndex].staff.find(s => s.id === staffItem.id)) {
                updatedTeams[teamIndex].staff.push({
                    ...staffItem,
                    isDriver: false,
                    isLead: false
                });
            }
        });
        setTeams(updatedTeams);
        setSelectedStaff([]);
        setAddStaffModalVisible(false);
    };

    const addObjectToTeam = (teamIndex, objectItems) => {
        const updatedTeams = [...teams];
        objectItems.forEach(objectItem => {
            if (!updatedTeams[teamIndex].objects.find(obj => obj.id === objectItem.id)) {
                updatedTeams[teamIndex].objects.push({
                    ...objectItem,
                    comment: ''
                });
            }
        });
        setTeams(updatedTeams);
        setSelectedObjects([]);
        setAddObjectsModalVisible(false);
    };

    const removeStaffFromTeam = (teamIndex, staffId) => {
        const updatedTeams = [...teams];
        updatedTeams[teamIndex].staff = updatedTeams[teamIndex].staff.filter(s => s.id !== staffId);

        if (updatedTeams[teamIndex].driver === staffId) {
            updatedTeams[teamIndex].driver = '';
        }
        if (updatedTeams[teamIndex].lead === staffId) {
            updatedTeams[teamIndex].lead = '';
        }

        setTeams(updatedTeams);
    };

    const removeObjectFromTeam = (teamIndex, objectId) => {
        const updatedTeams = [...teams];
        updatedTeams[teamIndex].objects = updatedTeams[teamIndex].objects.filter(obj => obj.id !== objectId);
        setTeams(updatedTeams);
    };

    const updateObjectComment = (teamIndex, objectId, comment) => {
        const updatedTeams = [...teams];
        const objectIndex = updatedTeams[teamIndex].objects.findIndex(obj => obj.id === objectId);
        if (objectIndex !== -1) {
            updatedTeams[teamIndex].objects[objectIndex].comment = comment;
            setTeams(updatedTeams);
        }
    };

    const updateTeamField = (teamIndex, field, value) => {
        const updatedTeams = [...teams];
        updatedTeams[teamIndex][field] = value;
        setTeams(updatedTeams);
    };

    const openAddStaffModal = (teamIndex) => {
        setCurrentTeamIndex(teamIndex);
        setSelectedStaff([]);
        setAddStaffModalVisible(true);
    };

    const openAddObjectsModal = (teamIndex) => {
        setCurrentTeamIndex(teamIndex);
        setSelectedObjects([]);
        setAddObjectsModalVisible(true);
    };

    const submitPlan = async (values) => {
        try {
            // Валидация
            if (teams.length === 0) {
                message.error('Должна быть хотя бы одна команда!');
                return;
            }

            const validatedTeams = teams.map((team, index) => {
                // Автоматически назначаем старшего и водителя если в команде 1 человек
                if (team.staff.length === 1 && (!team.lead || !team.driver)) {
                    const singleStaff = team.staff[0];
                    team.lead = singleStaff.id;
                    team.driver = singleStaff.id;
                    message.info(`В команде ${index + 1} автоматически назначен старший и водитель`);
                }

                // Проверяем обязательные поля
                if (team.objects.length === 0) {
                    throw new Error(`В команде ${index + 1} должен быть хотя бы один объект`);
                }

                if (!team.lead) {
                    throw new Error(`В команде ${index + 1} должен быть назначен старший`);
                }

                if (!team.driver && team.carId !== "99") {
                    throw new Error(`В команде ${index + 1} должен быть назначен водитель`);
                }

                return team;
            });

            setLoading(true);

            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            const createDate = Math.floor(tomorrow.getTime() / 1000);
            const usedDate = Math.floor(tomorrow.getTime() / 1000);

            if (edit && currentPlanId) {
                // РЕДАКТИРОВАНИЕ: Обновляем существующий план
                await instance.put(`plans/update_plan.php`, {
                    plan_id: currentPlanId,
                    maincomment: values.mainComment
                }, {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                // Удаляем старые команды
                await instance.delete(`plans/delete_plan_teams.php`, {
                    data: {plan_id: currentPlanId},
                    withCredentials: true,
                });

                // Добавляем обновленные команды
                for (const team of validatedTeams) {
                    await instance.post(`plans/post_plans_props.php`, {
                        parent_id: currentPlanId,
                        carId: team.carId,
                        driver: team.driver,
                        lead: team.lead,
                        staff_id: team.staff.map(s => s.id).join(','),
                        objects_id: team.objects.map(obj => obj.id).join(','),
                        comment: team.objects.map(obj => `${obj.comment}`).join('` '),
                        teamcomment: team.teamcomment
                    });
                }

                message.success('План успешно обновлен!');
                const requestBody = {
                    change: true,
                    link: `https://gdapp.org/current_plan/?${currentPlanId}`,
                };
                await whatsappApi.sendPlan(requestBody)

                // ПЕРЕЗАГРУЖАЕМ ДАННЫЕ С СЕРВЕРА
                await reloadPlanData();
            } else {
                // СОЗДАНИЕ: Создаем новый план
                const planResponse = await instance.post(`plans/post_plans.php`, {
                    create_date: createDate,
                    used_date: usedDate,
                    maincomment: values.mainComment
                });

                const planId = planResponse.data.planId;
                console.log(planResponse.data);
                console.log(planId);
                for (const team of validatedTeams) {
                    await instance.post(`plans/post_plans_props.php`, {
                        parent_id: planId,
                        carId: team.carId,
                        driver: team.driver,
                        lead: team.lead,
                        staff_id: team.staff.map(s => s.id).join(','),
                        objects_id: team.objects.map(obj => obj.id).join(','),
                        comment: team.objects.map(obj => `${obj.comment}`).join('` '),
                        teamcomment: team.teamcomment
                    });
                }

                message.success('План успешно создан!');
                const requestBody = {
                    change: false,
                    link: `https://gdapp.org/current_plan/?${planId}`,
                };
                await whatsappApi.sendPlan(requestBody)
                setPage('34');
            }

        } catch (error) {
            console.error('Error saving plan:', error);
            if (error.message) {
                message.error(error.message);
            } else {
                message.error('Ошибка при сохранении плана');
            }
        } finally {
            setLoading(false);
        }
    };

    if (initialLoading) {
        return <Loader/>;
    }

    return (
        <div style={{padding: 0, paddingBottom: 100, maxWidth: 1400, margin: '0 auto'}}>
            <TitleComp
                planNumber={planNumber}
                planTitle={planTitle}
            />

            <Form
                form={form}
                layout="vertical"
                onFinish={submitPlan}
            >
                <Card style={{marginBottom: 24}}>
                    <Row gutter={16}>
                        <Col xs={24}>
                            <Form.Item
                                name="mainComment"
                                label="Общий комментарий к плану"
                            >
                                <TextArea
                                    rows={8}
                                    placeholder="Введите общий комментарий к плану"
                                    style={{fontSize: '14px', lineHeight: '1.4'}}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Card>

                <Divider>Команды</Divider>

                {teams.map((team, index) => (
                    <TeamCard
                        key={team.id}
                        team={team}
                        index={index}
                        teams={teams}
                        cars={getAvailableCars()}
                        allcars={cars}
                        availableStaff={getAvailableStaff()}
                        availableObjects={getAvailableObjects()}

                        removeTeam={removeTeam}
                        updateTeamField={updateTeamField}
                        removeStaffFromTeam={removeStaffFromTeam}
                        removeObjectFromTeam={removeObjectFromTeam}
                        updateObjectComment={updateObjectComment}
                        openAddStaffModal={openAddStaffModal}
                        openAddObjectsModal={openAddObjectsModal}
                    />
                ))}

                <Button
                    type="dashed"
                    onClick={addTeam}
                    icon={<PlusOutlined/>}
                    style={{width: '100%', marginBottom: 24}}
                >
                    Добавить команду
                </Button>

                <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    size="large"
                    style={{width: '100%'}}
                >
                    {edit ? 'Обновить план' : 'Создать план'}
                </Button>
            </Form>

            <ModalsAndDrawers
                addStaffModalVisible={addStaffModalVisible}
                setAddStaffModalVisible={setAddStaffModalVisible}
                addObjectsModalVisible={addObjectsModalVisible}
                setAddObjectsModalVisible={setAddObjectsModalVisible}
                currentTeamIndex={currentTeamIndex}
                selectedStaff={selectedStaff}
                setSelectedStaff={setSelectedStaff}
                selectedObjects={selectedObjects}
                setSelectedObjects={setSelectedObjects}
                getAvailableStaff={getAvailableStaff} // Исправлено: правильное название
                getAvailableObjects={getAvailableObjects} // Исправлено: правильное название
                addStaffToTeam={addStaffToTeam}
                addObjectToTeam={addObjectToTeam}
                isMobile={isMobile}
            />
        </div>
    );
};

export default NewPlanning;